import React, { Component, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { DialogContent, DialogContentText, Link,Badge,Checkbox, Select,MenuItem,ListItemText,InputLabel, Box, FormControl,OutlinedInput, Container, Grid, Card, CardContent, CardHeader, Divider, Typography, Icon, LinearProgress, linearProgressClasses, CardActions, Button, Chip, CircularProgress, TextField , Radio, Dialog, DialogTitle} from '@mui/material';
import AddShoppingCart from '@mui/icons-material/AddShoppingCart'
import moment from 'moment';
import { Helmet } from 'react-helmet';
import * as _ from 'lodash'
import FormLabel from '@mui/material/FormLabel'
import { _freedomAxios,_axios } from 'src/plugins/axios';
import DialogBox from 'src/helpers/DialogBox';
import  FullDetails  from './PackageInfo';
import { Notify } from 'src/components/common/Notify';
import { styled } from '@mui/material/styles';
const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 18,
    height: 18,
    backgroundColor: 'white',
}));


export default function PackageCreation() {

    const [packages, setPackages] = React.useState([]);
    const [packageCreationList, setpackageCreationList] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');
    const navigate = useNavigate();
    const [dialogBoxPackage, setDialogBoxPackage] = React.useState("");
    const [dialogBoxPackageInfo, setDialogBoxPackageInfo] = React.useState({});
    const [totalSelectedPackages,setTotalSelectedPackages] = React.useState([]);
    const descriptionElementRef = React.useRef(null);
  
    const addToCart = (packageId,packageName) => {
        const packageIndex = packageCreationList.indexOf(packageId);
        if(packageIndex > -1){
           const list =  packageCreationList.filter(id => id !== packageId);
           const totalPacklist = totalSelectedPackages.filter((id, index) => index !== packageIndex);
            setpackageCreationList(list);
            setTotalSelectedPackages(totalPacklist);
        }
        else{
            setpackageCreationList(prevState => {
                return [
                  ...prevState,
                  packageId
                ];
              });
            setTotalSelectedPackages(prevState => {
              return [ ...prevState, {packageId,packageName}];
            })
        }
        
       { console.log("length", packageCreationList.length) }
       {console.log(totalSelectedPackages)}
    }
    const  packageSize = () => {
        const packageLength = packageCreationList.length;
        return packageLength;
    } 
    const redirectToPackageCreation = (packageIdList)=>{

        if(packageCreationList.length == 0) {
            return;
        }
        window.sessionStorage.setItem('selectedPackages',JSON.stringify(totalSelectedPackages));
        navigate('/app/ahcOnboarding/PackageCart', { replace: true })
    }

    const PackageDetails = () => {
        return (
            <Grid container spacing={2}>
                {dialogBoxPackageInfo.bio_markers ? dialogBoxPackageInfo.bio_markers.map((val,index) => (
                       <Grid item xs={8} key = {index}>
                            <TextField>{val.testId}</TextField>
                            <TextField>{val.packageName}</TextField>
                        </Grid> 
                )) : <></>}
            </Grid>
        )
    }

    function displayPackages() {

        _freedomAxios.get('corporate/productMaster')
        .then((response) => {
            if(response.data.isSuccess){
                const result = JSON.parse(response.data.result);
                setPackages(result);
            }
        })
        .catch((error) => {

        })
    }

    function PackageInfo(packageId, packageName) {
        setDialogBoxPackage(packageName);
        let payLoad = {
          "packageId" : [packageId],
        };
        _freedomAxios.
        post('corporate/packageInfo', payLoad)
        .then((response) => {
            if(response.data.isSuccess){
                let info = response.data.result;
                setDialogBoxPackageInfo(info);

            }
        })
        .catch((error) => {});
        console.log(dialogBoxPackage);
        setOpen(!open);
    }

    function Package(packageId, packageName,index) {
        return ( 
            <Grid container > 
              
            <Card sx={{ minWidth: 240, maxWidth: 260, borderRadius: '10'}} key = {index}>
            <Checkbox
            value = {packageId}
            inputProps={{ 'aria-label': 'controlled' }}
            color="secondary"
            onClick={(e) => addToCart(packageId,packageName)}
            />
            <CardContent>
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    {packageId}
              </Typography>
              <Typography variant="h5" component="div">
                    {packageName}
              </Typography>
            </CardContent>
            <CardActions>
              <Button size="small" onClick={ (e) => PackageInfo(packageId,packageName) }>Package Info</Button>
            </CardActions>
            </Card>
            </Grid>
        );
      }

    useEffect(() => {
        if (open) {
          const { current: descriptionElement } = descriptionElementRef;
          if (descriptionElement !== null) {
            descriptionElement.focus();
          }
        }
    }, [open]);

    useEffect(() => {
        displayPackages();
    }, [])

    return (
        <Box sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            margin:'2%',
            py: 2
          }}>
              <Grid container direction="row" justifyContent="flex-end" alignItems="flex-end" mb = '2%'>
                     <TextField sx = {{margin: '1%'}}id="standard-basic" label="Search" variant="standard" />   
                     <Link component="button" ariant="body2"
                            onClick={() => redirectToPackageCreation()}
                            >
                        <Badge badgeContent={packageSize()} color="secondary">
                                <AddShoppingCart style= { { width: '6vw', height: '5vh'}}></AddShoppingCart>
                        </Badge>
                     </Link>
              </Grid>
             <Grid container spacing = {2}>
                {packages.map((val, index) => {
                        return (<Grid item key = {val.PM_Id}>
                            {Package(val.PM_Id,val.PM_Name,index)}
                        </Grid>)
                    })}
             </Grid>
             {/* {open && <DialogBox tittle = {dialogBoxPackage} />} */}
             <Dialog open = {open} 
                  onClose = {(e) => setOpen(!open)} 
                  scroll = {scroll}
                  aria-labelledby="scroll-dialog-title"
                  aria-describedby="scroll-dialog-description">
                  <DialogTitle id="scroll-dialog-title" color = "primary"> {dialogBoxPackage} </DialogTitle>
                    
                     <DialogContent dividers={scroll === 'paper'}>
                         <DialogContentText
                               id="scroll-dialog-description"
                               ref={descriptionElementRef}
                               tabIndex={-1}
                          >
                              <FullDetails bio_markers={dialogBoxPackageInfo.bio_markers} profiles = {dialogBoxPackageInfo.profiles} />
                          </DialogContentText>
                      </DialogContent>
               </Dialog>     
        </Box>
    )
}